import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { monthEndAlertConstants } from '../../actions/constant';
import monthEndAlertsService from '../../../services/apiServices/monthEndAlert/monthEndALerts';

const {
  REQUEST_GET_STATUS_CERTIFY,
  SUCCESS_GET_STATUS_CERTIFY,
  FAILURE_GET_STATUS_CERTIFY,
  LOADING_GET_STATUS_CERTIFY,
} = monthEndAlertConstants;

function* getCertificationStatus(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_STATUS_CERTIFY });

    
    const response = yield call(monthEndAlertsService.getCertificationStatus, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_STATUS_CERTIFY, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_STATUS_CERTIFY, payload: error });
  }
}

function* getCertificationStatusSaga() {
  yield takeEvery(REQUEST_GET_STATUS_CERTIFY, getCertificationStatus);
}

export default getCertificationStatusSaga;
